// extracted by mini-css-extract-plugin
export var column = "social-networks-column-module--column--85870";
export var iconsContainer = "social-networks-column-module--iconsContainer--566b7";
export var pictogram = "social-networks-column-module--pictogram--064e3";
export var title = "social-networks-column-module--title--357cf";